module.exports = __webpack_public_path__ + "static/media/17@2x.7549380a.png";